/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */

define('modules/Product/UnitsOfMeasure',[
    'jquery',
    'lodash',
    'global/all',
    'modules/Product/ProductService'
], function ($, _, Roc, ProductService) {
    'use strict';

    var selectors = {
        unitsOfMeasurePanel: '#unitsOfMeasure',
        selectedUnitOfMeasure: '#selectedUom',
        priceLabelWrapper: '.productDetailsQty > .productUnit',     /* CUSTOM LINE :: price and qty labels */
        quantityLabelWWrapper: '.itemQuantity > .itemQtyTotal',     /* CUSTOM LINE :: price and qty labels */
        purchaseQuantityInput: '#purchaseQuantity'                  /* CUSTOM LINE :: price and qty labels */
    };

    /* CUSTOMIZATION START :: price and qty labels */
    var unitsOfMeasure;
    var maximumQty = 999999;
    var qtyInAlternateUnit;
    var priceLabelDefaultViewModel = {
        selectedUnitOfMeasureEnabled: false,
        addonEnabled: false,
        selectedUnitOfMeasure: null,
        quantityInAlternateUnit: 0
    };
    var quantityLabelDefaultViewModel = {
        enabled: false,
        userQuantity: 0,
        quantityInAlternateUnit: 0
    };
    /* CUSTOMIZATION END :: price and qty labels */

    var selectedUomAfterSelectionsUpdate;

    /**
     * getUnitsOfMeasureInfoForProduct(productId) returns an object 
     * containing unit of measure info ready for rendering in the unitsOfMeasure-Tmp template.
     */
    function getUnitsOfMeasureInfoForProduct(productViewModel) {

        if (productViewModel) {
            var selectedUomId = productViewModel.productPricing && productViewModel.productPricing.unitOfMeasure
                ? productViewModel.productPricing.unitOfMeasure.id
                : $(selectors.selectedUnitOfMeasure).val();
            return {
                productId: productViewModel.id,
                unitsOfMeasure: productViewModel.availableUnitsOfMeasure,
                selectedUomId: selectedUomId || null
            };
        }
        return null;
    }

    function reloadAvailableUnitsOfMeasure(productViewModel) {

        var units = getUnitsOfMeasureInfoForProduct(productViewModel);
        render(units).then(function () {
            //On Group product page in order to preselect UoM we need to wait for selections to be updated
            if (selectedUomAfterSelectionsUpdate && productViewModel.productType == 'Simple') {
                $(selectors.selectedUnitOfMeasure).val(selectedUomAfterSelectionsUpdate);
                processUnitChangeEvent();
                selectedUomAfterSelectionsUpdate = null;
            }
        });
    }

    function render(options) {
        return Roc.UI.renderFormTemplate('unitsOfMeasure-Tmp', options, $(selectors.unitsOfMeasurePanel));
    }

    function bindUnitChange() {
        Roc.UI.siteBody
            .off('change', selectors.selectedUnitOfMeasure)
            .on('change', selectors.selectedUnitOfMeasure, function () {
                processUnitChangeEvent();
            });
    }

    function processUnitChangeEvent() {
        var $uom = $(selectors.selectedUnitOfMeasure);
        var selectedUomId = $uom.val() || "";
        var productId = $uom.attr('data-roc-productId');
        /* CUSTOMIZATION START :: Adding spinner  */
        var selector = ('[data-roc-wrapper="productDetailsQty"]');
        Roc.UI.block(selector);
        ProductService.getByIdAndUom(productId, selectedUomId)
            .then(function (product) {
                Roc.EventManager.notify(Roc.Events.products.SELECTIONS_UPDATE, product);
            })
            .always(function () {
                Roc.UI.unblock(selector);
            });
        /* CUSTOMIZATION END */
    }

    function bindEvents() {
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadAvailableUnitsOfMeasure);
        bindUnitChange();
        /* CUSTOMIZATION START :: price and qty labels */
        selectedUomChangeEvt();
        purchaseQuantityInputChangeEvt();
        /* CUSTOMIZATION END :: price and qty labels */
    }

    /* CUSTOMIZATION START :: price and qty labels */
    function priceAndQuantityLabelsEnabled() {
        return Array.isArray(unitsOfMeasure) && unitsOfMeasure.length > 0 && qtyInAlternateUnit > 0;
    }

    function purchaseQuantityInputChangeEvt() {
        var changeEventNamespace = '.unitsOfMeasure-purchaseQuantityInputChangeEvt';
        var changeEventArray = ['change'];
        var changeEvent = Roc.EventBuilder.buildName(changeEventArray, changeEventNamespace);

        if (!priceAndQuantityLabelsEnabled()) {
            Roc.UI.attachEventHandler(changeEvent, selectors.purchaseQuantityInput, function () {
                validateQty(this);
            });
            return;
        }

        Roc.UI.attachEventHandler(changeEvent, selectors.purchaseQuantityInput, function () {
            validateQty(this);
            updatePriceAndQuantityLabels();
        });
    }

    function selectedUomChangeEvt() {
        if (!priceAndQuantityLabelsEnabled()) {
            return;
        }

        var changeEventNamespace = '.unitsOfMeasure-selectedUomChangeEvt';
        var changeEventArray = ['change'];
        var changeEvent = Roc.EventBuilder.buildName(changeEventArray, changeEventNamespace);

        Roc.UI.attachEventHandler(changeEvent, selectors.selectedUnitOfMeasure, function () {
            updatePriceAndQuantityLabels();
        });
    }

    function validateQty(qtySelector) {
        var qtyValue = $(qtySelector).val() || "0";
        var currentQty = $(qtySelector).data("rocCurrentQty");

        var currentValue = parseInt(qtyValue);

        if (isNaN(currentValue) || currentValue < 0 || currentValue > maximumQty) {
            Roc.UI.displayErrorPopup('There appears to be a problem with your quantity. Please try again and enter a valid quantity.');
            $(qtySelector).val(currentQty);
            return;
        }
        $(qtySelector).data("rocCurrentQty", qtyValue);
    }
    function updatePriceAndQuantityLabels() {
        if (!priceAndQuantityLabelsEnabled()) {
            return;
        }
        //make a copy of default vm, set props, render views and put into document
        var priceLabelViewModel = _.cloneDeep(priceLabelDefaultViewModel);
        var quantityLabelViewModel = _.cloneDeep(quantityLabelDefaultViewModel);

        var selectedUnitOfMeasureName = "";
        var uniqueUnitOfMeasureList = _.uniq(unitsOfMeasure, 'id');
        if (uniqueUnitOfMeasureList.length == 2) {
            selectedUnitOfMeasureName = $(selectors.selectedUnitOfMeasure + ' option:selected').text();
        } else {
            selectedUnitOfMeasureName = $(selectors.selectedUnitOfMeasure).attr('data-roc-selected-uom-name');
        }

        priceLabelViewModel.selectedUnitOfMeasure = selectedUnitOfMeasureName;
        // SelectedUnitOfMeasureEnabled if:
        // - qtyInAlternateUnit >= 1 
        // - selectedUnitOfMeasureName is not null or empty

        if (qtyInAlternateUnit >= 1 && !!selectedUnitOfMeasureName) {
            var selectedUOM = selectedUnitOfMeasureName.toLowerCase();
            switch (selectedUOM) {
                // selectedUnitOfMeasureName should be present as first item in unitsOfMeasure array
                case unitsOfMeasure[0].name.toLowerCase():
                    priceLabelViewModel.selectedUnitOfMeasureEnabled = true;
                    priceLabelViewModel.quantityInAlternateUnit = unitsOfMeasure[0].customFields["soldByQty"];
                    quantityLabelViewModel.quantityInAlternateUnit = unitsOfMeasure[0].customFields["soldByQty"];
                    break;
                    // alternate unit is selected (it should be present as second item in unitsOfMeasure array) 
                case unitsOfMeasure[1].name.toLowerCase():
                    priceLabelViewModel.addonEnabled = true;
                    priceLabelViewModel.quantityInAlternateUnit = unitsOfMeasure[1].customFields["soldByQty"];
                    quantityLabelViewModel.quantityInAlternateUnit = unitsOfMeasure[1].customFields["soldByQty"];
                    break;
            }
        }

        quantityLabelViewModel.userQuantity = parseInt($(selectors.purchaseQuantityInput).val());
        if (!$.isNumeric(quantityLabelViewModel.userQuantity) || quantityLabelViewModel.userQuantity < 0) {
            quantityLabelViewModel.userQuantity = 0;
        }

        // Enabled if: 
        // - qtyInAlternateUnit >= 1
        // - alternate unit name is not null or empty
        // - alternate unit is selected (it should be present as first item in unitsOfMeasure array) 
        quantityLabelViewModel.enabled = qtyInAlternateUnit >= 1
            && !!selectedUnitOfMeasureName
            && (unitsOfMeasure.length == 2) && selectedUnitOfMeasureName.toLowerCase() === unitsOfMeasure[0].name.toLowerCase();


        Roc.UI.template('unitOfMeasurePriceLabel-Tmp', priceLabelViewModel).then(function (renderedTemplate) {
            $(selectors.priceLabelWrapper).html(renderedTemplate);
        });

        Roc.UI.template('unitOfMeasureQuantityLabel-Tmp', quantityLabelViewModel).then(function (renderedTemplate) {
            $(selectors.quantityLabelWWrapper).html(renderedTemplate);
        });
    }
    /* CUSTOMIZATION END :: price and qty labels */

    function init(options) {
        var unitChangeProcessed = false;
        if (options && options.uomId) {
            if (!options.hasSelections) {
                $(selectors.selectedUnitOfMeasure).val(options.uomId);
                processUnitChangeEvent();
                unitChangeProcessed = true;
            } else {
                //after selections will be updated on group product page
                //and uom selection will be rendered we will update uom on a simple product
                selectedUomAfterSelectionsUpdate = options.uomId;
            }
        }

        /* CUSTOMIZATION START :: price and qty labels */
        if (options && options.unitOfMeasureList && parseInt(options.quantityInAlternateUnit)) {
            unitsOfMeasure = options.unitOfMeasureList;
            qtyInAlternateUnit = parseInt(options.quantityInAlternateUnit);
        }
        /* CUSTOMIZATION END :: price and qty labels */

        bindEvents();
        updatePriceAndQuantityLabels(); /* CUSTOM LINE :: price and qty labels */
        // Triggering a unit change in order for the price to update with the default sold by UoM - without this update we'd show the wrong price
        //CUSTOMIZATION START : Calling UnitChangeEvent only when UOM options are available
        if (options && !unitChangeProcessed) {
            processUnitChangeEvent();
        }
        //CUSTOMIZATION END
    }

    var UnitsOfMeasure = {
        init: init,
        getUnitsOfMeasureInfoForProduct: getUnitsOfMeasureInfoForProduct
    }

    Roc.Logger.debug('UnitsOfMeasure.js Loaded:', UnitsOfMeasure);

    return UnitsOfMeasure;
});
